import padStart from 'lodash-es/padStart';
import dateGetDayOfTheWeek from 'date-fns/get_day';
import dateGetMonthOfTheYear from 'date-fns/get_month';
import dateSetDayOfTheWeek from 'date-fns/set_day';
import dateSetDayOfTheMonth from 'date-fns/set_date';
import dateSetMonthOfTheYear from 'date-fns/set_month';
import dateSetHourOfTheDay from 'date-fns/set_hours';
import dateSetMinuteOfTheHour from 'date-fns/set_minutes';
import dateAddDays from 'date-fns/add_days';
import dateAddWeeks from 'date-fns/add_weeks';
import dateAddMonths from 'date-fns/add_months';
import dateAddYears from 'date-fns/add_years';
import dateSubMonths from 'date-fns/sub_months';
import dateSubYears from 'date-fns/sub_years';
import dateIsDate from 'date-fns/is_date';
import dateIsSameDay from 'date-fns/is_same_day';
import dateIsSameMonth from 'date-fns/is_same_month';
import dateIsValidDate from 'date-fns/is_valid';
import dateFormat from 'date-fns/format';
import dateParse from 'date-fns/parse';
import dateIsAfter from 'date-fns/is_after';
import dateIsBefore from 'date-fns/is_before';

export const printDateObjectAsFormattedString = (date, formatting) => {
    return dateFormat(date, formatting);
}

export const parseDateStringAsDateObject = (date) => {
    return dateParse(date);
}

export const printDateObjectAsISOWithoutTime = (date) => {
    return printDateObjectAsFormattedString(date, 'YYYY-MM-DD');
}

export const printDateObjectAsAmericanDate = (date) => {
    return printDateObjectAsFormattedString(date, 'MM/DD/YYYY');
}

export const addDaysToDate = (date, days) => {
    days = typeof days !== 'undefined' && days !== null ? days : 0;
    return dateAddDays(date, days);
}

export const addWeeksToDate = (date, weeks) => {
    weeks = typeof weeks !== 'undefined' && weeks !== null ? weeks : 0;
    return dateAddWeeks(date, weeks);
}

export const addMonthsToDate = (date, months) => {
    months = typeof months !== 'undefined' && months !== null ? months : 0;
    return dateAddMonths(date, months);
}

export const addYearsToDate = (date, years) => {
    years = typeof years !== 'undefined' && years !== null ? years : 0;
    return dateAddYears(date, years);
}

export const getMonthFromDate = (date) => {
    return dateGetMonthOfTheYear(date);
}

export const getDayOfWeekFromDate = (date) => {
    return dateGetDayOfTheWeek(date);
}

export const setSpecificDayOfMonthOnDate = (date, dayOfMonth) => {
    return dateSetDayOfTheMonth(date, dayOfMonth);
}

export const setSpecificDayOfWeekOnDate = (date, dayOfWeek) => {
    return dateSetDayOfTheWeek(date, dayOfWeek);
}

export const setSpecificMonthOnDate = (date, monthOfYear) => {
    return dateSetMonthOfTheYear(date, monthOfYear);
}

export const setSpecificHourOnDate = (date, hour) => {
    return dateSetHourOfTheDay(date, hour);
}

export const setSpecificMinuteOnDate = (date, minute) => {
    return dateSetMinuteOfTheHour(date, minute);
}

export const checkIfTimestampIsOlderThanXMinutes = (timestamp, minutes) => {
    const now = Date.now();
    const minutesMiliseconds = minutes * 60 * 1000;
    return now - timestamp > minutesMiliseconds;
}

export const checkIfDateIsValidDate = (date) => {
    return dateIsDate(date);
}

export const checkIfDateIsAfterOtherDate = (dateAssumedBefore, dateAssumedAfter) => {
    return dateIsAfter(dateAssumedBefore, dateAssumedAfter);
}

export const checkIfDateIsBeforeOtherDate = (dateAssumedAfter, dateAssumedBefore) => {
    return dateIsBefore(dateAssumedAfter, dateAssumedBefore);
}

export const checkIfTwoDatesAreOnTheSameDay = (date1, date2) => {
    return dateIsSameDay(date1, date2);
}

export const checkIfTwoDatesAreInTheSameMonth = (date1, date2) => {
    return dateIsSameMonth(date1, date2);
}



// WEBPACK FOOTER //
// ./app/web/src/helpers/Date.js